// Contenido y opciones de estructura del sitio. Edita este archivo para personalizar la landing page.
export const site = {
  name: "Patas & Burbujas",
  logo: "",
  tagline: "Estética canina y felina con veterinario en casa",
  description: "Estética canina y felina con veterinario en casa",
  email: "reservas@patasyburbujas.example",
  phone: "+52 442 000 0000",
} as const;

/** Textos de la portada. */
export const hero = {
  eyebrow: "Bienvenido",
  primaryLabel: "Solicitar información",
  secondaryLabel: "Ver servicios",
} as const;

/** Enlaces del menú principal (anclas a las secciones de la página). */
export const navLinks = [
  { label: "Servicios", href: "#servicios" },
  { label: "Nosotros", href: "#nosotros" },
  { label: "Galería", href: "#galeria" },
  { label: "Precios", href: "#precios" },
  { label: "Contacto", href: "#contacto" },
] as const;

/** Destinos de los botones principales. */
export const links = {
  home: "#inicio",
  services: "#servicios",
  contact: "#contacto",
} as const;

export type HeaderStyle = "simple" | "centered";
export type HeaderPosition = "sticky" | "static";
export type FooterStyle = "simple" | "columns";

/** Opciones de estructura: cambia un valor y los componentes de layout se adaptan. */
export const layout: { header: HeaderStyle; headerPosition: HeaderPosition; footer: FooterStyle } = {
  header: "simple",
  headerPosition: "sticky",
  footer: "columns",
};
